import { render, staticRenderFns } from "./Parceria_Senalba.vue?vue&type=template&id=3678fdf5"
import script from "./Parceria_Senalba.vue?vue&type=script&lang=js"
export * from "./Parceria_Senalba.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Senalba.vue?vue&type=style&index=0&id=3678fdf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports